export const gateNames = {
  chartingReminders: 'fg_charting_reminders',
  displayJobCancelButtonAtPageTop: 'bring_cancel_button_to_top_of_job_details_page',
  docAi530Verification: 'doc_ai_530_verification',
  earningsRefresh: 'pro_earnings_refresh',
  earningsShiftBreakdown: 'pro_earnings_shift_hours_breakdown',
  findJobsInfiniteScroll: 'find_jobs_infinite_scroll',
  inAppDisputeResolution: 'pro_in_app_dispute_resolution',
  permanentPlacement: 'fg_permanent_placement',
  proCardRedesign: 'pro_job_card_redesign',
  proClockOutSupervisorSignature: 'pro_clock_out_supervisor_signature',
  proClockOutSupervisorSignatureOT: 'pro_clock_out_supervisor_signature_ot',
  proGeolocationAdjustments: 'fg_pro_geolocation_adjustments',
  proGraphqlTransformations: 'pro_graphql_transformations',
  proPool: 'fg_pro_pool',
  proShiftConfirmationExperience: 'lx_ns_check_in_experience',
  proStoreReviewPrompting: 'fg_mobile_store_review_prompting',
  proStripeCompanyRep: 'pro_stripe_company_rep',
  proTempTimesheetsEnableAllShiftTypes: 'fg_mobile_timesheets',
  pushNotifications: 'fg_mobile_push_notifications',
  roundClockOut: 'pro_round_clock_out',
  splitPay: 'split_pay',
  taxUiUplift: 'pro_tax_ui_uplift',
  termsOfService: 'terms_of_service',
  topLevelBookButton: 'top_level_book_button',
  qualificationAutomationEnabled: 'credential_automation_ui',
  xrTransparency: 'pro_xr_transparency',
  fgClockOutBreaks: 'fg_clock_out_breaks',
  shiftPaidNotification: 'fg_shift_paid_notification',
  referralLinkGate: 'fg_referral_link',
  onboardingVideoURL: 'onboardingVideoURL',
  verifiedExternalAccount: 'verified_external_account',
  twoFactorAuth: 'fg_mfa',
  twoFactorAuthMobile: 'fg_mfa_mobile',
  earningsPendingOldAdjustment: 'fg_earnings_pending_old_adjustment',
  onboardingMobileRedesign: 'fg_onboarding_mobile_redesign',
  proPoolAutomation: 'fg_pro_pool_automation',
  referralsOnMobile: 'fg_referral_link_mobile',
  w2_interest_feature: 'fg_w2_interest_collecttion',
  disableSegmentIntercomEvents: 'fg_disable_segment_intercom_events',
  rescreening_automation: 'fg_rescreening_automation',
  specialty_speedbump_extension: 'fg_speedbump_extension',
  direct_shift_release_pro: 'fg_direct_shift_release_pro',
  earlyDeparture: 'fg_early_departure',
  debugMode: 'fg_debug_mode',
  mobile_application_flow_gate: 'fg_mp_application',
  applicationVideo: 'applicationVideoURL',
  proAppVideo: 'fg_pro_app_video',
  appVideoAutopopup: 'fg_app_video_autopopup',
  rateNegotiation: 'fg_rate_negotiation',
  facilityInfoInWh: 'fg_facility_info_in_wh',
};

export const experimentNames = {
  ahaEcode: {
    name: 'aha_ecode',
  },
  preScreeningXP: {
    name: 'xp_prescreening',
    parameters: {
      applicationVersion: 'application_version',
    },
  },
};

export const dynamicConfigNames = {
  educationalVideos: 'dc_educational_videos',
  schedulingPrefsConfig: 'scheduling_prefs_config',
  earlyDepartureConfig: 'dc_early_departure',
};
